// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_RtMrS","bonus-products-wrap":"bonus-products-wrap_PVBRq"};